import React from 'react';
import { Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { handlePurchaseItemCreateUpdate } from '../../../commonHandlerFunction/Purchase/Items/ItemsHandler';
import { handleBranchMasterCreateUpdate } from '../../../commonHandlerFunction/Purchase/DepartmentandBranchHandler/BrachnHandler';
import { handleDepartmentCreateUpdate } from '../../../commonHandlerFunction/Purchase/DepartmentandBranchHandler/DepartmentHandler';


const DeleteButton = ({ formData, handleSubmit, setIsOverlayLoader, viewOnly, setFormData, formConfig }) => {

    const navigate = useNavigate();
    return (

        <div className="auditBtns">
            <Button
                type="button"
                className="cancelBtn"
                onClick={() => navigate("/departmentList")}
            >
                Back
            </Button>
            {
                !viewOnly && (


                    <Button
                        type="button"
                        className="submitBtn"
                        onClick={() =>
                            handleDepartmentCreateUpdate(formData, handleSubmit, setIsOverlayLoader, navigate, formConfig)
                        }
                    >

                        Save
                    </Button>



                )
            }



        </div>
    )
}

export default DeleteButton
